module.exports = __webpack_public_path__ + "img/16.87778153.svg";